/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Create_SubmitInputs */

const en_us2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const pt_br2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

const es_419_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const pt_pt2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

const fr_fr2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

const de_de2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const it_it2_clubs_create_submit = /** @type {(inputs: Clubs_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Clubs_Create_SubmitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_create_submit = /** @type {((inputs?: Clubs_Create_SubmitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Create_SubmitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_create_submit(inputs)
	if (locale === "es-419") return es_419_clubs_create_submit(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_create_submit(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_create_submit(inputs)
	if (locale === "de-DE") return de_de2_clubs_create_submit(inputs)
	if (locale === "it-IT") return it_it2_clubs_create_submit(inputs)
	return en_us2_clubs_create_submit(inputs)
});
export { clubs_create_submit as "clubs.create_submit" }